import React, { useState } from 'react'
import { format } from 'date-fns'
import imageCorbeille from '../../../images/corbeille.png'

const BookingToCome = ({ booking, user, _converteTimeToHours, setIdResetBooking }) => {
    const [currentDate, setCurrentDate] = useState(format(new Date(Date.now()), 'MM/dd/yyyy'))

    return ( 
        <div className='mt-3'>
            {user.uid && 
            <>
                {booking.filter(b => b.uidClient === user.uid && b.date >= currentDate && b.cancel !== true).map(b => ( 
                    <div className='mt-3 row border rounded text-center mx-3' style={{backgroundColor:'#99d6edff'}} key={b.id}>
                        <div className='col-2' />
                        <div className='p-2 col' style={{ color:'grey'}}>Prochain RDV : {b.dateShow} à {_converteTimeToHours(b.hours)}</div>
                        <div 
                            className='col-2 text-end' /*onClick={() => _deleteBooking(b.id)}*/ 
                        >
                            <img 
                                src={imageCorbeille} 
                                alt='corbeille' 
                                style={{ height:'1.5rem', width:'1.5rem', marginTop:'0.5rem', cursor:'pointer' }} 
                                data-bs-toggle="modal" 
                                data-bs-target="#modalConfirm"
                                onClick={() => setIdResetBooking(b.id)}
                            />
                        </div>
                    </div>
                ))}
            </>
            } 
        </div>
    )
}

export default BookingToCome
